import { createSelector } from '@ngrx/store';

import { SCANN_TO_BASKET_FEATURE_KEY } from '../constants';
import { selectScanState } from '../main-selector';
import { ScantoBasketState } from '../models';

import { adapter } from './scan-to-basket.reducer';

export const selectScanToBasketState = createSelector(
  selectScanState,
  (state) => state[SCANN_TO_BASKET_FEATURE_KEY],
);

export const { selectAll: selectScannedBasketProducts } = adapter.getSelectors(
  selectScanToBasketState,
);

export const selectScannedProductUpdating = (productId: string) =>
  createSelector(
    selectScanToBasketState,
    (state: ScantoBasketState) => state.updatingScannedProductIdMap[productId],
  );
